import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/login.vue'),
  },
  // 个人中心
  {
    meta: {
      title: '个人中心'// 标题设置
    },
    path: '/user',
    name: 'User',
    component: () => import(/* webpackChunkName: "User" */ '../views/user/index.vue'),
    redirect: '/user/personal',
    children: [
      {
        meta: {
          title: '个人中心'// 标题设置
        },
        path: '/user/personal',
        name: 'Personal',
        component: () => import(/* webpackChunkName: "Personal" */ '../views/user/personal.vue'),
      },
      {
        path: '/user/password',
        name: 'Password',
        component: () => import(/* webpackChunkName: "Password" */ '../views/user/password.vue'),
      },
      {
        path: '/user/company',
        name: 'userCompany',
        component: () => import(/* webpackChunkName: "userCompany" */ '../views/user/company.vue'),
      }

    ]
  },
  // 以下为动态路由，项目完成后需删除下面所有的路由
  // 配件管理
  {
    path: '/parts',
    name: 'Parts',
    component: () => import(/* webpackChunkName: "Parts" */ '../views/parts/index.vue'),
    redirect: '/parts/management',
    children: [
      {
        path: '/parts/management',
        name: 'PartsManagement',
        component: () => import(/* webpackChunkName: "PartsManagement" */ '../views/parts/management.vue'),
      },
      {
        path: '/parts/classification',
        name: 'Classification',
        component: () => import(/* webpackChunkName: "Classification" */ '../views/parts/classification.vue'),
      },
      {
        path: '/parts/brand',
        name: 'Brand',
        component: () => import(/* webpackChunkName: "Brand" */ '../views/parts/brand.vue'),
      },
      {
        path: '/parts/company',
        name: 'Company',
        component: () => import(/* webpackChunkName: "Company" */ '../views/parts/company.vue')
      }
    ]
  },
  // 订单管理
  {
    path: '/order',
    name: 'Order',
    component: () => import(/* webpackChunkName: "Order" */ '../views/order/index.vue'),
    redirect: '/order/management',
    children: [
      {
        path: '/order/service',
        name: 'orderService',
        component: () => import(/* webpackChunkName: "orderService" */ '../views/order/service.vue'),
      },
      {
        path: '/order/card',
        name: 'orderCard',
        component: () => import(/* webpackChunkName: "orderCard" */ '../views/order/card.vue'),
      },
      {
        path: '/order/dataStatistics',
        name: 'dataStatistics',
        component: () => import(/* webpackChunkName: "dataStatistics" */ '../views/order/dataStatistics.vue'),
      },
      {
        path: '/order/vipCardStatistics',
        name: 'vipCardStatistics',
        component: () => import(/* webpackChunkName: "dataStatistics" */ '../views/order/vipCardStatistics.vue'),
      },
      {
        path: '/order/projectStatistics',
        name: 'projectStatistics',
        component: () => import(/* webpackChunkName: "dataStatistics" */ '../views/order/projectStatistics.vue'),
      },
      {
        path: '/order/cashBackStatistics',
        name: 'cashBackStatistics',
        component: () => import(/* webpackChunkName: "dataStatistics" */ '../views/order/cashBackStatistics.vue'),
      }
      //
    ]
  },
  // 采购管理
  {
    path: '/purchase',
    name: 'Purchase',
    component: () => import(/* webpackChunkName: "Purchase" */ '../views/purchase/index.vue'),
    redirect: '/purchase/management',
    children: [
      {
        path: '/purchase/management',
        name: 'PurchaseManagement',
        component: () => import(/* webpackChunkName: "PurchaseManagement" */ '../views/purchase/management.vue'),
      },
      {
        path: '/purchase/detailed',
        name: 'PurchaseDetailed',
        component: () => import(/* webpackChunkName: "PurchaseDetailed" */ '../views/purchase/detailed.vue'),
      },
      {
        path: '/purchase/supplier',
        name: 'supplier',
        component: () => import(/* webpackChunkName: "Supplier" */ '../views/purchase/supplier.vue'),
      },
      {
        path: '/purchase/addItem',
        name: 'addItem',
        component: () => import(/* webpackChunkName: "addItem" */ '../views/purchase/addItem.vue'),
      },
      {
        path: '/purchase/readyUseParts',
        name: 'readyUseParts',
        component: () => import(/* webpackChunkName: "readyUseParts" */ '../views/purchase/readyUseParts.vue'),
      },
      {
        path: '/purchase/commonParts',
        name: 'commonParts',
        component: () => import(/* webpackChunkName: "commonParts" */ '../views/purchase/commonParts.vue'),
      },
      {
        path: '/purchase/returnGoods',
        name: 'returnGoods',
        component: () => import(/* webpackChunkName: "returnGoods" */ '../views/purchase/returnGoods.vue'),
      },
      {
        path: '/purchase/editReturnGoods',
        name: 'editReturnGoods',
        component: () => import(/* webpackChunkName: "editReturnGoods" */ '../views/purchase/editReturnGoods.vue'),
      },
      {
        path: '/purchase/waitPurchaseList',
        name: 'waitPurchaseList',
        component: () => import(/* webpackChunkName: "editReturnGoods" */ '../views/purchase/waitPurchaseList.vue'),
      }
    ]
  },
  //门店管理
  {
    path: '/framework',
    name: 'Framework',
    component: () => import(/* webpackChunkName: "Framework" */ '../views/framework/index.vue'),
    redirect: '/framework/management',
    children: [
      {
        path: '/framework/management',
        name: 'frameworkManagement',
        component: () => import(/* webpackChunkName: "FrameworkManagement" */ '../views/framework/management.vue'),
      },
      {
        path: '/framework/role',
        name: 'frameworkRole',
        component: () => import(/* webpackChunkName: "FrameworkRole" */ '../views/framework/role.vue'),
      },
      {
        path: '/framework/management/edit',
        name: 'frameworkEdit',
        component: () => import(/* webpackChunkName: "FrameworkEdit" */ '../views/framework/edit.vue'),
      },
      // 门店新增，仅总门店有权限
      {
        path: '/framework/management/add',
        name: 'frameworkAdd',
        component: () => import(/* webpackChunkName: "FrameworkEdit" */ '../views/framework/edit.vue'),
      },
      // 师傅展示
      {
        path: '/framework/mechanic',
        name: 'Mechanic',
        component: () => import(/* webpackChunkName: "mechanic" */ '../views/framework/mechanic.vue'),
      },
      {
        path: '/framework/mechanic/add',
        name: 'MechanicAdd',
        component: () => import(/* webpackChunkName: "MechanicAdd" */ '../views/framework/mechanicAdd.vue'),
      },
      {
        path: '/framework/jurisdiction',
        name: 'Jurisdiction',
        component: () => import(/* webpackChunkName: "Jurisdiction" */ '../views/framework/jurisdiction.vue'),
      },
      {
        path: '/framework/menu',
        name: 'Menu',
        component: () => import(/* webpackChunkName: "Menu" */ '../views/framework/menu.vue'),
      },
      {
        path: '/framework/menuAdd',
        name: 'MenuAdd',
        component: () => import(/* webpackChunkName: "MenuAdd" */ '../views/framework/menuAdd.vue'),
      },

    ]
  },

  // 项目管理
  {
    path: '/project',
    name: 'Project',
    component: () => import(/* webpackChunkName: "Purchase" */ '../views/project/index.vue'),
    redirect: '/project/repair',
    children: [
      {
        path: '/project/repair',
        name: 'ProjectRepair',
        component: () => import(/* webpackChunkName: "ProjectRepair" */ '../views/project/repair.vue'),
      },
      {
        path: '/project/service',
        name: 'projectService',
        component: () => import(/* webpackChunkName: "ProjectService" */ '../views/project/service.vue'),
      },
      {
        path: '/project/projectParts',
        name: 'projectParts',
        component: () => import(/* webpackChunkName: "ProjectService" */ '../views/project/projectParts.vue'),
      },
      {
        path: '/project/projectManage',
        name: 'projectManage',
        component: () => import(/* webpackChunkName: "ProjectService" */ '../views/project/projectManage.vue'),
      },
      {
        path: '/project/packageManage',
        name: 'packageManage',
        component: () => import(/* webpackChunkName: "ProjectService" */ '../views/project/packageManage.vue'),
      }

    ]
  },
  // 前台收银
  {
    path: '/',
    name: 'CashRegister',
    component: () => import(/* webpackChunkName: "CashRegister" */ '../views/cashRegister/index.vue'),
    redirect: '/cashRegister/billing',
    children: [
      {
        path: '/cashRegister/billing',
        name: 'Billing',
        component: () => import(/* webpackChunkName: "Billing" */ '../views/cashRegister/billing.vue'),
      },
      {
        path: '/cashRegister/cardSell',
        name: 'cardSell',
        component: () => import(/* webpackChunkName: "Billing" */ '../views/cashRegister/cardSell.vue'),
      },
      {
        path: '/cashRegister/billing/billingDetail',
        name: 'BillingDetail',
        component: () => import(/* webpackChunkName: "BillingDetail" */ '../views/cashRegister/billingDetail.vue'),
      },
      {
        path: '/cashRegister/worksettlement',
        name: 'worksettlement',
        component: () => import(/* webpackChunkName: "worksettlement" */ '../views/cashRegister/worksettlement.vue'),
      },
      {
        path: '/cashRegister/settlementList',
        name: 'settlementList',
        component: () => import(/* webpackChunkName: "settlementList" */ '../views/cashRegister/settlementList.vue'),
      },
      {
        path: '/cashRegister/PartsSale',
        name: 'PartsSale',
        component: () => import(/* webpackChunkName: "PartsSale" */ '../views/cashRegister/PartsSale.vue'),
      },
      {
        path: '/cashRegister/reconciliationList',
        name: 'reconciliationList',
        component: () => import(/* webpackChunkName: "reconciliationList" */ '../views/cashRegister/reconciliationList.vue'),
      },
      {
        path: '/cashRegister/reconciliationList/incomeListByDay',
        name: 'incomeListByDay',
        component: () => import(/* webpackChunkName: "reconciliationList" */ '../views/cashRegister/incomeListByDay.vue'),
      },
      {
        path: '/cashRegister/fadeList',
        name: 'fadeList',
        component: () => import(/* webpackChunkName: "reconciliationList" */ '../views/cashRegister/fadeList.vue'),
      },
      {
        path: '/cashRegister/fadeList/fadeBillDetail',
        name: 'fadeBillDetail',
        component: () => import(/* webpackChunkName: "reconciliationList" */ '../views/cashRegister/fadeBillDetail.vue'),
      }
    ]
  },
  //运营管理
  {
    path: '/operate',
    name: 'operate',
    component: () => import(/* webpackChunkName: "operate" */ '../views/operate/index.vue'),
    redirect: '/operate/index',
    children: [
      {
        path: '/operate/coupon',
        name: 'operateCoupon',
        component: () => import(/* webpackChunkName: "operateCoupon" */ '../views/operate/coupon.vue')
      },
      {
        path: '/operate/coupon_add',
        name: 'operateCoupon_add',
        component: () => import(/* webpackChunkName: "operateCoupon_add" */ '../views/operate/coupon_add.vue')
      },
      {
        path: '/operate/coupon_info',
        name: 'operateCoupon_info',
        component: () => import(/* webpackChunkName: "operateCoupon_info" */ '../views/operate/coupon_info.vue')
      },
      {
        path: '/operate/appointment',
        name: 'Appointment',
        component: () => import(/* webpackChunkName: "Appointment" */ '../views/operate/appointment.vue')
      },
      {
        path: '/operate/appointmentAdd',
        name: 'AppointmentAdd',
        component: () => import(/* webpackChunkName: "AppointmentAdd" */ '../views/operate/appointmentAdd.vue')
      },
      {
        path: '/operate/VipCard',
        name: 'VipCard',
        component: () => import(/* webpackChunkName: "VipCard" */ '../views/operate/VipCard.vue')
      },
      {
        path: '/operate/VipCardPlan',
        name: 'VipCardPlan',
        component: () => import(/* webpackChunkName: "VipCard" */ '../views/operate/VipCardPlan.vue')
      },
      {
        path: '/operate/vipCardAdd',
        name: 'VipCardAdd',
        component: () => import(/* webpackChunkName: "VipCardAdd" */ '../views/operate/vipCardAdd.vue')
      },
      {
        path: '/operate/vipCardEdit',
        name: 'VipCardEdit',
        component: () => import(/* webpackChunkName: "VipCardAdd" */ '../views/operate/vipCardAdd.vue')
      },
      {
        path: '/operate/operation',
        name: 'Operation',
        component: () => import(/* webpackChunkName: "Operation" */ '../views/operate/operation/index.vue'),
      },

      {
        path: '/operate/reappearance',
        name: 'Reappearance',
        component: () => import(/* webpackChunkName: "Reappearance" */ '../views/operate/reappearance.vue')
      },
      // 尊享卡项目
      {
        path: '/operate/vipClass',
        name: 'VipClass',
        component: () => import(/* webpackChunkName: "VipClass" */ '../views/operate/vipClass.vue')
      },
      // 尊享卡项目
      {
        path: '/operate/vipClassParts',
        name: 'vipClassParts',
        component: () => import(/* webpackChunkName: "vipClassParts" */ '../views/operate/vipClassParts.vue')
      },
      // 项目分类
      {
        path: '/operate/projectType',
        name: 'ProjectType',
        component: () => import(/* webpackChunkName: "ProjectType" */ '../views/operate/projectType.vue')
      },
      // 项目分类编辑
      {
        path: '/operate/editProjectType',
        name: 'EditProjectType',
        component: () => import(/* webpackChunkName: "EditProjectType" */ '../views/operate/editProjectType.vue')
      },
      {
        path: '/operate/evaluation',
        name: 'evaluation',
        component: () => import(/* webpackChunkName: "evaluation" */ '../views/operate/evaluation.vue')
      },
      {
        path: '/operate/preabout',
        name: 'preabout',
        component: () => import(/* webpackChunkName: "preabout" */ '../views/operate/preabout.vue')
      },
      {
        path: '/operate/banner',
        name: 'banner',
        component: () => import(/* webpackChunkName: "banner" */ '../views/operate/banner.vue')
      },
      //微信菜单
      {
        path: '/operate/wechatMenu',
        name: 'wechatMenu',
        component: () => import(/* webpackChunkName: "wechatMenu" */ '../views/operate/wechatMenu.vue')
      },
    ]
  },
  //基本设置
  {
    path: '/general',
    name: 'general',
    component: () => import(/* webpackChunkName: "personnel" */ '../views/general/index.vue'),
    redirect: '/general/index',
    children: [
      {
        path: '/general/serviceType',
        name: 'serviceType',
        component: () => import(/* webpackChunkName: "serviceType" */ '../views/general/serviceType.vue')
      },
      {
        path: '/general/repaircompany',
        name: 'repaircompany',
        component: () => import(/* webpackChunkName: "repaircompany" */ '../views/general/repaircompany.vue')
      },
      {
        path: '/general/Partner',
        name: 'Partner',
        component: () => import(/* webpackChunkName: "Partner" */ '../views/general/Partner.vue')
      },
      {
        path: '/general/insurance',
        name: 'insurance',
        component: () => import(/* webpackChunkName: "insurance" */ '../views/general/insurance.vue')
      },
      {
        path: '/general/collection',
        name: 'collection',
        component: () => import(/* webpackChunkName: "collection" */ '../views/general/collection.vue')
      },
      {
        path: '/general/returnvisit',
        name: 'returnvisit',
        component: () => import(/* webpackChunkName: "returnvisit" */ '../views/general/returnvisit.vue')
      },
      {
        path: '/general/carcheckproject',
        name: 'carcheckproject',
        component: () => import(/* webpackChunkName: "carcheckproject" */ '../views/general/carcheckproject.vue')
      },
      {
        path: '/general/carcheckgroup',
        name: 'carcheckgroup',
        component: () => import(/* webpackChunkName: "carcheckgroup" */ '../views/general/carcheckgroup.vue')
      },

    ]
  },
  //业务报表
  {
    path: '/BusinessReport',
    name: 'BusinessReport',
    component: () => import(/* webpackChunkName: "BusinessReport" */ '../views/BusinessReport/index.vue'),
    redirect: '/BusinessReport/index',
    children: [
      {
        path: '/BusinessReport/projectSell',
        name: 'projectSell',
        component: () => import(/* webpackChunkName: "projectSell" */ '../views/BusinessReport/projectSell.vue')
      },
      {
        path: '/BusinessReport/projectConstruction',
        name: 'ProjectConstruction',
        component: () => import(/* webpackChunkName: "ProjectConstruction" */ '../views/BusinessReport/projectConstruction.vue')
      },
      {
        path: '/BusinessReport/mountingsSell',
        name: 'mountingsSell',
        component: () => import(/* webpackChunkName: "mountingsSell" */ '../views/BusinessReport/mountingsSell.vue')
      },
      {
        path: '/BusinessReport/partsConstruction',
        name: 'PartsConstruction',
        component: () => import(/* webpackChunkName: "PartsConstruction" */ '../views/BusinessReport/partsConstruction.vue')
      },
      {
        path: '/BusinessReport/businessSummary',
        name: 'businessSummary',
        component: () => import(/* webpackChunkName: "ProfitSummary" */ '../views/BusinessReport/businessSummary.vue')
      },
      {
        path: '/BusinessReport/businessSummary/businessSummaryDetail',
        name: 'businessSummaryDetail',
        component: () => import(/* webpackChunkName: "ProfitSummary" */ '../views/BusinessReport/businessSummaryDetail.vue')
      },
      {
        path: '/BusinessReport/profitSummary',
        name: 'ProfitSummary',
        component: () => import(/* webpackChunkName: "ProfitSummary" */ '../views/BusinessReport/profit.vue')
      },
      {
        path: '/BusinessReport/profitStatistics',
        name: 'profitStatistics',
        component: () => import(/* webpackChunkName: "ProfitSummary" */ '../views/BusinessReport/profitStatistics.vue')
      },

      {
        path: '/BusinessReport/dailyStatistics',
        name: 'dailyStatistics',
        component: () => import(/* webpackChunkName: "ProfitSummary" */ '../views/BusinessReport/dailyStatistics.vue')
      },

    ]
  },
  //会员管理
  {
    path: '/member',
    name: 'member',
    component: () => import(/* webpackChunkName: "member" */ '../views/member/index.vue'),
    redirect: '/member/index',
    children: [
      {
        path: '/member/memberlist',
        name: 'memberlist',
        component: () => import(/* webpackChunkName: "memberlist" */ '../views/member/memberlist.vue')
      },
      {
        path: '/member/LevelList',
        name: 'LevelList',
        component: () => import(/* webpackChunkName: "LevelList" */ '../views/member/LevelList.vue')
      },
      {
        path: '/member/memberCard',
        name: 'memberCard',
        component: () => import(/* webpackChunkName: "LevelList" */ '../views/member/memberCard.vue')
      },

    ]
  },
  //员工管理
  {
    path: '/personnel',
    name: 'Personnel',
    component: () => import(/* webpackChunkName: "personnel" */ '../views/personnel/index.vue'),
    redirect: '/personnel/index',
    children: [
      {
        path: '/personnel/staff',
        name: 'personnelStaff',
        component: () => import(/* webpackChunkName: "personnelStaff" */ '../views/personnel/staff.vue')
      },
      {
        path: '/personnel/branch',
        name: 'personnelBranch',
        component: () => import(/* webpackChunkName: "personnelBranch" */ '../views/personnel/branch.vue')
      },
      {
        path: '/personnel/position',
        name: 'personnelPosition',
        component: () => import(/* webpackChunkName: "personnelPosition" */ '../views/personnel/position.vue')
      },
      {
        path: '/personnel/operationLogList',
        name: 'operationLogList',
        component: () => import(/* webpackChunkName: "operationLogList" */ '../views/personnel/operationLogList.vue')
      },

    ]
  },
  //仓库管理
  {
    path: '/warehouse',
    name: 'Warehouse',
    component: () => import(/* webpackChunkName: "warehouse" */ '../views/warehouse/index.vue'),
    redirect: '/warehouse/index',
    children: [
      {
        path: '/warehouse/libraryList',
        name: 'warehouselibraryList',
        component: () => import(/* webpackChunkName: "warehouselibraryList" */ '../views/warehouse/libraryList.vue')
      },
      {
        path: '/warehouse/exceed',
        name: 'exceed',
        component: () => import(/* webpackChunkName: "warehouselibraryList" */ '../views/warehouse/libraryList.vue')
      },
      {
        path: '/warehouse/create',
        name: 'warehouselicreate',
        component: () => import(/* webpackChunkName: "warehouselicreate" */ '../views/warehouse/create.vue')
      },
      {
        path: '/warehouse/purchaseWarehousing',
        name: 'purchaseWarehousing',
        component: () => import(/* webpackChunkName: "purchaseWarehousing" */ '../views/warehouse/purchaseWarehousing.vue')
      },
      {
        path: '/warehouse/partsStockList',
        name: 'partsStockList',
        component: () => import(/* webpackChunkName: "partsStockList" */ '../views/warehouse/partsStockList.vue')
      },
      {
        path: '/warehouse/enterPin',
        name: 'enterPin',
        component: () => import(/* webpackChunkName: "enterPin" */ '../views/warehouse/enterPin.vue')
      },
      {
        path: '/warehouse/pickingInfo',
        name: 'pickingInfo',
        component: () => import(/* webpackChunkName: "pickingInfo" */ '../views/warehouse/pickingInfo.vue')
      },
      {
        path: '/warehouse/editReturnWarehouse',
        name: 'editReturnWarehouse',
        component: () => import(/* webpackChunkName: "pickingInfo" */ '../views/warehouse/editReturnWarehouse.vue')
      },
      {
        path: '/warehouse/createOutBill',
        name: 'createOutBill',
        component: () => import(/* webpackChunkName: "createOutBill" */ '../views/warehouse/createOutBill.vue')
      },
      {
        path: '/warehouse/createInBill',
        name: 'createInBill',
        component: () => import(/* webpackChunkName: "createInBill" */ '../views/warehouse/createInBill.vue')
      },
      {
        path: '/warehouse/purchaseInBill',
        name: 'purchaseInBill',
        component: () => import(/* webpackChunkName: "purchaseInBill" */ '../views/warehouse/purchaseInBill.vue')
      },
      {
        path: '/warehouse/positionManagement',
        name: 'positionManagement',
        component: () => import(/* webpackChunkName: "positionManagement" */ '../views/warehouse/positionManagement.vue')
      },
    ]
  },
  //财务管理
  {
    path: '/Bookkeeping',
    name: 'Bookkeeping',
    component: () => import(/* webpackChunkName: "Bookkeeping" */ '../views/Bookkeeping/index.vue'),
    redirect: '/Bookkeeping/index',
    children: [
      {
        path: '/Bookkeeping/incomeList',
        name: 'incomeList',
        component: () => import(/* webpackChunkName: "incomeList" */ '../views/Bookkeeping/incomeList.vue')
      },
      {
        path: '/Bookkeeping/expenditureList',
        name: 'expenditureList',
        component: () => import(/* webpackChunkName: "expenditureList" */ '../views/Bookkeeping/expenditureList.vue')
      },
      {
        path: '/Bookkeeping/fixedList',
        name: 'fixedList',
        component: () => import(/* webpackChunkName: "fixedList" */ '../views/Bookkeeping/fixedList.vue')
      },
      {
        path: '/Bookkeeping/workList',
        name: 'workList',
        component: () => import(/* webpackChunkName: "workList" */ '../views/Bookkeeping/workList.vue')
      },
      {
        path: '/Bookkeeping/purchaseList',
        name: 'purchaseList',
        component: () => import(/* webpackChunkName: "purchaseList" */ '../views/Bookkeeping/purchaseList.vue')
      },
      {
        path: '/Bookkeeping/payBills',
        name: 'PayBills',
        component: () => import(/* webpackChunkName: "PayBills" */ '../views/Bookkeeping/payBills.vue')
      },
      {
        path: '/Bookkeeping/otherList',
        name: 'otherList',
        component: () => import(/* webpackChunkName: "otherList" */ '../views/Bookkeeping/otherList.vue')
      },
      {
        path: '/Bookkeeping/Withdrawal',
        name: 'Withdrawal',
        component: () => import(/* webpackChunkName: "Withdrawal" */ '../views/Bookkeeping/Withdrawal.vue')
      },
      {
        path: '/Bookkeeping/rechargeLog',
        name: 'rechargeLog',
        component: () => import(/* webpackChunkName: "rechargeLog" */ '../views/Bookkeeping/rechargeLog.vue')
      },
      {
        path: '/Bookkeeping/SettlementMonth',
        name: 'SettlementMonth',
        component: () => import(/* webpackChunkName: "SettlementMonth" */ '../views/Bookkeeping/SettlementMonth.vue')
      },
      {
        path: '/Bookkeeping/BalanceLog',
        name: 'BalanceLog',
        component: () => import(/* webpackChunkName: "BalanceLog" */ '../views/Bookkeeping/BalanceLog.vue')
      },
      {
        path: '/Bookkeeping/AdminCashCenter',
        name: 'AdminCashCenter',
        component: () => import(/* webpackChunkName: "AdminCashCenter" */ '../views/Bookkeeping/AdminCashCenter.vue')
      },

    ]
  },
  //客户服务
  {
    path: '/customer',
    name: 'Customer',
    component: () => import(/* webpackChunkName: "Customer" */ '../views/customer/index.vue'),
    redirect: '/customer/vehicle',
    children: [
      {
        path: '/customer/vehicle',
        name: 'Vehicle',
        component: () => import(/* webpackChunkName: "Vehicle" */ '../views/customer/vehicle.vue')
      },
      {
        path: '/customer/carRank',
        name: 'CarRank',
        component: () => import(/* webpackChunkName: "CarRank" */ '../views/customer/carRank.vue')
      },
      {
        path: '/customer/returnVisit',
        name: 'ReturnVisit',
        component: () => import(/* webpackChunkName: "ReturnVisit" */ '../views/customer/returnVisit.vue')
      },
      {
        path: '/customer/expire',
        name: 'Expire',
        component: () => import(/* webpackChunkName: "Expire" */ '../views/customer/expire.vue')
      },
      {
        path: '/customer/expire/edit',
        name: 'ExpireEdit',
        component: () => import(/* webpackChunkName: "ExpireEdit" */ '../views/customer/expireEdit.vue')
      },
      {
        path: '/customer/expire/serviceHistory',
        name: 'ServiceHistory',
        component: () => import(/* webpackChunkName: "ServiceHistory" */ '../views/customer/serviceHistory.vue')
      },
      {
        path: '/customer/expire/follow',
        name: 'Follow',
        component: () => import(/* webpackChunkName: "Follow" */ '../views/customer/follow.vue')
      },
      {
        path: '/customer/schedule/index',
        name: 'Schedule',
        component: () => import(/* webpackChunkName: "Follow" */ '../views/customer/schedule.vue')
      },
    ]
  },
  //新客户服务
  {
    path: '/newCustomer',
    name: 'NewCustomer',
    component: () => import(/* webpackChunkName: "NewCustomer" */ '../views/newCustomer/index.vue'),
    redirect: '/newCustomer/vehicle',
    children: [
      {
        path: '/newCustomer/vehicle',
        name: 'NewVehicle',
        component: () => import(/* webpackChunkName: "NewVehicle" */ '../views/newCustomer/vehicle.vue')
      },
      {
        path: '/newCustomer/carRank',
        name: 'NewCarRank',
        component: () => import(/* webpackChunkName: "NewCarRank" */ '../views/newCustomer/carRank.vue')
      },
      {
        path: '/newCustomer/returnVisit',
        name: 'NewReturnVisit',
        component: () => import(/* webpackChunkName: "NewReturnVisit" */ '../views/newCustomer/returnVisit.vue')
      },
      {
        path: '/newCustomer/expire',
        name: 'NewExpire',
        component: () => import(/* webpackChunkName: "NewExpire" */ '../views/newCustomer/expire.vue')
      },
      {
        path: '/newCustomer/expire/edit',
        name: 'NewExpireEdit',
        component: () => import(/* webpackChunkName: "NewExpireEdit" */ '../views/newCustomer/expireEdit.vue')
      },
      {
        path: '/newCustomer/expire/serviceHistory',
        name: 'NewServiceHistory',
        component: () => import(/* webpackChunkName: "NewServiceHistory" */ '../views/newCustomer/serviceHistory.vue')
      },
      {
        path: '/newCustomer/followRecord',
        name: 'NewFollowRecord',
        component: () => import(/* webpackChunkName: "NewServiceHistory" */ '../views/newCustomer/followRecord.vue')
      },
      {
        path: '/newCustomer/expire/follow',
        name: 'NewFollow',
        component: () => import(/* webpackChunkName: "NewFollow" */ '../views/newCustomer/follow.vue')
      },
      {
        path: '/newCustomer/schedule/index',
        name: 'NewSchedule',
        component: () => import(/* webpackChunkName: "NewSchedule" */ '../views/newCustomer/schedule.vue')
      },
      {
        path: '/newCustomer/guarantee',
        name: 'NewGuarantee',
        component: () => import(/* webpackChunkName: "NewGuarantee" */ '../views/newCustomer/guarantee.vue')
      },
      {
        path: '/newCustomer/static',
        name: 'NewStatic',
        component: () => import(/* webpackChunkName: "NewStatic" */ '../views/newCustomer/static.vue')
      },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
